import { StatusPill, type PillTone } from '../../components';
import { formatCount } from '../../lib/format/money';
import type { LocaleActivityRow, SupplyDemandFlag } from './api';

/** Locale display bits shared by the Community Activation table and map. */

const FLAG: Record<SupplyDemandFlag, { label: string; tone: PillTone }> = {
  chef_shortage: { label: 'recruit chefs', tone: 'danger' },
  eater_shortage: { label: 'recruit eaters', tone: 'warning' },
  balanced: { label: 'balanced', tone: 'success' },
};

export function Balance({ r }: { r: LocaleActivityRow }) {
  const f = FLAG[r.supplyDemandFlag] ?? { label: r.supplyDemandFlag, tone: 'neutral' as PillTone };
  // No active chefs: the ratio is undefined (not infinite) and the flag is always chef shortage.
  if (r.supplyDemandRatio === null) {
    return (
      <StatusPill tone="danger" dot title={`${formatCount(r.eaterCount)} eaters, no active chefs`}>
        no active chefs
      </StatusPill>
    );
  }
  return (
    <StatusPill tone={f.tone} dot title="eaters per active chef">
      {Math.round(r.supplyDemandRatio)}:1 · {f.label}
    </StatusPill>
  );
}

/** "120% of target" — sold vs the locale's weekly target; "no target" when none is set. */
export function ofTarget(r: LocaleActivityRow): string {
  return r.dishesSoldTargetPerWeek > 0 ? `${Math.round(r.activityPct)}% of target` : 'no target';
}
